import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs'

@Injectable()
export class LoggingService {

    constructor(private http: HttpClient) { }

    private apiKey
    private error = new Deduplicator()
    private info = new Deduplicator()
    private warn = new Deduplicator()

    logError(payload: Payload, correlationId): Observable<any> {
        let correlationHeader = correlationId && { 'X-Correlation-Id': correlationId }
        return this.error.log(this.enrich(payload), p => this.http.put(`/_mvc/booking/log/errors`, p, { headers: { ...correlationHeader, ...this.apiKey } }))
    }

    logInfo(payload: Payload): Observable<any> {
        return this.info.log(this.enrich(payload), p => this.http.put(`/_mvc/booking/log/info`, p, { headers: this.apiKey }))
    }

    logWarn(payload: Payload): Observable<any> {
        return this.warn.log(this.enrich(payload), p => this.http.put(`/_mvc/booking/log/warn`, p, { headers: this.apiKey }))
    }

    public setApiKey(key) {
        this.apiKey = { 'X-Api-Key': key }
    }

    private enrich(p: Payload) {
        return {
            userAgent: navigator.userAgent,
            path: window.location.pathname,
            query: window.location.search,
            ...p
        }
    }

}

export class Deduplicator {
    lastMessage: Payload
    lastResult: Observable<any>

    log(payload: Payload, action: (payload: Payload) => Observable<any>) {
        if (this.lastMessage && JSON.stringify(this.lastMessage) == JSON.stringify(payload)) {
            return this.lastResult
        }
        const s = new ReplaySubject(1)
        action(payload).subscribe(o => s.next(o), e => console.error(e), () => s.complete())
        this.lastMessage = payload
        return this.lastResult = s
    }
}

export interface Payload {
    message: string
    path?: string
    query?: string
    stacktrace?: string
    params?: any[]
}
